import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

import { unwrapNonBold } from '../utils';

import { SANITIZE_PROFILE_DEFAULT } from './default';

export const SANITIZE_PROFILE_WIDGETCHAT: SanitizationOption = {
  allowedTags: [
    'b',
    'i',
    'strong',
    'em',
    'a',
    'ul',
    'ol',
    'li',
    'br',
    'code',
    'div',
    'p',
    'img',
    'pre',
    'placeholderp',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'blockquote',
    'span',
  ],
  allowedAttributes: {
    '*': ['dir'],
    a: ['href', 'target', 'rel'],
    img: ['src', 'alt'],
    em: ['class'],
  },
  allowedClasses: {
    em: ['highlight'],
  },
  transformTags: {
    p: 'placeholderp',
    b: unwrapNonBold,
    strong: unwrapNonBold,
  },
  allowedSchemes: SANITIZE_PROFILE_DEFAULT.allowedSchemes,
};
